<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="600px">
      <material-card
        v-if="(item !== null && item !== undefined) || provider !== undefined"
        :title="$t('components.membersmanagementtable.details')"
        :color="$vuetify.theme.themes.light.primary"
        icon="visibility"
      >
        <v-card-text>
          <div class="row no-gutters" v-if="type === 'Payment'">
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.pendinghourreports.Term Name") }}
              <br />
              <span class="minfo">
                {{ trans(item.Term, "Name") }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.type") }}
              <br />
              <span class="minfo">
                {{ $t(`enums.${item.Type}`) }}
              </span>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              {{ $t("globals.date") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatDate(item.PaymentDate) }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.amount") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatCurrency(item.Amount) }}
              </span>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              {{ $t("views.planbalance.cheque_number") }}
              <br />
              <span class="minfo">
                {{ item.PaymentNumber }}
              </span>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              {{ $t("headers.selfpayments.deposited") }}
              <br />
              <span class="minfo">
                {{ item.Deposited ? $t("globals.yes") : $t("globals.no") }}
              </span>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              {{ $t("headers.payments.deposited_date") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatDate(item.DepositedAt) }}
              </span>
            </div>
          </div>
          <div class="row no-gutters" v-else-if="type === 'Expense'">
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("components.balancepayments.expenseform.expense_party") }}
              <br />
              <span class="minfo">
                {{ $t(`enums.${expenseParty}`) }}
              </span>
            </div>
            <div
              class="col-12 col-md-4 col-lg-3 col-xl-2"
              v-if="expenseParty === 'Employer'"
            >
              {{ $t("globals.employer") }}
              <br />
              <span class="minfo">
                {{ trans(item.Employer, "Name") }}
              </span>
            </div>
            <div
              class="col-12 col-md-4 col-lg-3 col-xl-2"
              v-if="expenseParty === 'Store'"
            >
              {{ $t("globals.store") }}
              <br />
              <span class="minfo">
                {{ trans(item.Store, "Name") }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("components.balancepayments.expenseform.pay_to") }}
              <br />
              <span class="minfo">
                {{ $t(`enums.${paidParty}`) }}
              </span>
            </div>
            <div
              class="col-12 col-md-4 col-lg-3 col-xl-2"
              v-if="paidParty === 'InsuranceCarrier'"
            >
              {{ $t("globals.insurance_carrier") }}
              <br />
              <span class="minfo">
                {{ trans(item.InsuranceCarrier, "Name") }}
              </span>
            </div>
            <div
              class="col-12 col-md-4 col-lg-3 col-xl-2"
              v-if="paidParty === 'TrustFund'"
            >
              {{ $t("headers.expenses.trust_fund") }}
              <br />
              <span class="minfo">
                {{ trans(item.TrustFund, "Name") }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("headers.pendinghourreports.Term Name") }}
              <br />
              <span class="minfo">
                {{ trans(item.Term, "Name") }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.description") }}
              <br />
              <span class="minfo">
                {{ item.Description }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.amount") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatCurrency(item.Amount) }}
              </span>
            </div>
            <div class="col-12 col-md-4 col-lg-3 col-xl-2">
              {{ $t("globals.type") }}
              <br />
              <span class="minfo">
                {{ $t(`enums.${item.Type}`) }}
              </span>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              {{ $t("globals.date") }}
              <br />
              <span class="minfo">
                {{ $helpers.formatDate(item.ExpenseDate) }}
              </span>
            </div>
          </div>
          <pbas-data-table
            v-else-if="type === 'HoursReport' || type === 'HoursImport'"
            ref="table"
            :dataProvider="provider"
            fileNamePrefix="employersContributionsHistoryHoursDetails"
            :identifier="`contributionsHistoryHoursDetails${id}`"
            @error="error = $event"
            :showSelect="false"
            @itemsChanged="setData"
          ></pbas-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="warningDialog" persistent max-width="800">
      <material-card
        :title="$t('globals.warning')"
        icon="warning"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{
            $t("components.employer_contributions_history_table.warning_text")
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="warningDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="navigateToMember">
            {{ $t("views.dashboard.navigate") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translate2 } from "@/trans2";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/ContributionsHistoryHoursDetails";
export default {
  props: ["model", "id", "type", "hasLocations", "employerId"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      item: null,
      expenseParty: null,
      paidParty: null,
      error: null,
      provider: undefined,
      memberIdentityId: null,
      warningDialog: false,
      btnListeners: [],
    };
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadItem();
        }
      },
    },
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  mounted() {
    console.log("1111111111111111111111111", this.model);
    if (this.model) {
      this.loadItem();
    }
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("click", listener);
    });
  },
  methods: {
    ...mapActions("plansMembers", ["getPaymentById", "getExpenseById"]),
    trans(item, field) {
      return translate2(item, field);
    },
    close() {
      this.$emit("close");
      this.item = null;
    },
    async loadItem() {
      console.log("2222222222222222222222222", this.type);
      this.loading = true;
      try {
        if (this.type === "Payment") {
          this.provider = undefined;
          this.item = (
            await this.getPaymentById({
              planIdentityId: this.selectedPlan.Id,
              id: this.id,
            })
          ).data;
        } else if (this.type === "Expense") {
          this.provider = undefined;
          this.item = (
            await this.getExpenseById({
              planIdentityId: this.selectedPlan.Id,
              id: this.id,
            })
          ).data;

          this.expenseParty =
            this.item.Employer !== null && this.item.Employer !== undefined
              ? "Employer"
              : "Store";
          this.paidParty =
            this.item.InsuranceCarrier !== null &&
            this.item.InsuranceCarrier !== undefined
              ? "InsuranceCarrier"
              : "TrustFund";
        } else if (this.type === "HoursReport") {
          this.item = null;
          let url =
            "plans/" + this.selectedPlan.Id + "/hour-reports/" + this.id;
          this.provider = new ODataProvider(
            this.$axiosHttp,
            url,
            getHeaders(this.hasLocations)
          );
        } else if (this.type === "HoursImport") {
          this.item = null;
          let url =
            "plans/" +
            this.selectedPlan.Id +
            "/employers/" +
            this.employerId +
            "/hours-import/" +
            this.id;
          if (this.hasLocations) {
            url =
              "plans/" +
              this.selectedPlan.Id +
              "/employers/" +
              this.employerId +
              "/stores/" +
              this.storeId +
              "/hours-import/" +
              this.id;
          }
          this.provider = new ODataProvider(
            this.$axiosHttp,
            url,
            getHeaders(this.hasLocations)
          );
        }
        console.log("333333333333333333333333333", this.item);
        this.$forceUpdate();
      } catch (error) {
        this.error = error;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    setData(data) {
      console.log("@@@@@@@@@@@@@@", data);
      this.$nextTick(() => {
        for (let item of data) {
          let btn = document.getElementById(item.MemberId);
          console.log(btn);

          const listener = () =>
            this.navigateWarning({
              memberIdentityId: item.MemberId,
            });
          btn.addEventListener("click", listener, false);
          this.btnListeners.push({ btn, listener });
        }
      });
    },
    navigateWarning({ memberIdentityId }) {
      this.memberIdentityId = memberIdentityId;
      this.warningDialog = true;
    },
    navigateToMember() {
      this.$router.push({
        name: "memberView",
        params: { id: this.memberIdentityId },
      });
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
